import React, { useCallback, useEffect, useRef, useState } from "react";
import "./index.less";
import { Button, Cascader, Form, Input, Modal } from "antd";
import Tinymce from "@/components/Tinymce";
import UploadImage from "@/components/UploadImage";

interface QuestionFormProps {
  navEvent?: () => void;
  categoryOptions: any[];
  saveQuestion?: () => void;
  form:any
}

const prefix = "question-form";
const QuestionForm = (props: QuestionFormProps) => {
  const { navEvent, categoryOptions ,saveQuestion,form} = props;
  const descriptionRef=useRef<any>(null);
  const [uploadImageVisible, setUploadImageVisible] =useState(false);//图片上传弹窗
  const [imagesFiles, setImagesFiles] = useState<any[]>([]);//图片文件
  const totalImageSize=Math.round(imagesFiles.reduce((pre,cur:any)=>pre+cur.size,0)/1024);
  const onUploadImageCancel=useCallback(()=>{
    setUploadImageVisible(false);
  },[])
  const back = () => {
    
    navEvent && navEvent();
  };
  const submit = () => {
    console.log("submit");
    saveQuestion&& saveQuestion();
  };

  const onDesChange=useCallback(
    /**
     * 描述更改
     * @param value 
     */
    (value:any) => {
    form.setFieldsValue({ description: value });
  },[])
  const uploadImage = useCallback(() => {
    console.log("uploadImage");
    setUploadImageVisible(true);
  },[])
  const addUploadImageButton=useCallback(()=>{
    if(descriptionRef.current==null) return;
    descriptionRef.current.addToolBarPlugin('uploadImage',{
      icon:'image',
      tooltip:'插入图片',
      onAction:uploadImage
    });
  },[])
  /**
   * 插入图片
   */
  const insertImage=useCallback((files:any[])=>{
    console.log("insertImage",files);
    setImagesFiles(pre=>[...pre,...files]);
    files.forEach((file:any)=>{
      descriptionRef.current.insertContent(`<img  src="${file.url}" />`);
    })
  },[])
  const onCateoryChange = () => {
    console.log("onCateoryChange");
  };
  return (
    <div className={prefix}>
      <div className={prefix + "-navbar"} onClick={back}>
        <img src={require("@/assets/images/support/arrow-icon.png")} alt="" />
        返回上一页
      </div>

      <div className={prefix + "-header"}>我要提问</div>

      <div className={prefix + "-content"}>
        <Form form={form} onFinish={submit}>
          <Form.Item label="提问人" name="quizzer" required rules={[{ required: true, message: "请填写提问人" },
            {
              max: 64,
              message: "最大输入64个字符",
            },
          ]}>
            <Input type="text" placeholder="公司名称 或 个人名称" />
          </Form.Item>
          <Form.Item
            label={<span>&nbsp;&nbsp;&nbsp;联系方式</span>}
            rules={[
              {
                max: 64,
                message: "最大输入64个字符",
              },
            ]}
            name="contact"
          >
            <Input placeholder="请输入您的邮箱或手机号，方便我们更好的帮您定位解决问题" />
          </Form.Item>
          <Form.Item label="问题分类" name="typeId" required rules={[{ required: true, message: "请选择问题分类" }]}>
            <Cascader
              className={""}
              popupClassName={"questions-category-cascader"}
              value={form.getFieldValue("typeId")}
              options={categoryOptions}
              onChange={onCateoryChange}
              placeholder="请选择分类"
            />
          </Form.Item>
          <Form.Item
            label="版本/型号"
            name="versions"
            required
            rules={[
              {
                required: true,
                message: "请填写系统版本号及芯片型号，如“KaihongOS Stan. 4.1.3/RK3588",
              },
              {
                max: 64,
                message: "最大输入64个字符",
              },
            ]}
          >
            <Input type="text" placeholder="请填写系统版本号及芯片型号，如“KaihongOS Stan. 4.1.3/RK3588“" />
          </Form.Item>
          <Form.Item
            label="问题概述"
            name="overview"
            required
            rules={[
              {
                required: true,
                message: "请输入问题概述",
              },
              {
                max: 256,
                message: "最大输入256个字符",
              },
            ]}
          >
            <Input type="text" placeholder="一句话描述您的问题" />
          </Form.Item>
         
          <Form.Item
            label="问题描述"
            rules={[
              {
                required: true,
                message: "请输入问题描述",
              },
              {
                max: 12000,
                message: "最大输入12000个字符",
              }
              
            ]}
            name="description"
          >
            <div>
              <Tinymce 
                ref={descriptionRef}
                value={form.getFieldValue("description")}
                changeValue={onDesChange}
                onInit={addUploadImageButton}
              />
              {/* 图片上传 每张大小限制500kb 总大小不超过5mb */}
              <UploadImage 
                open={uploadImageVisible}
                onCancel={onUploadImageCancel}
                onOk={insertImage}
                totalSize={totalImageSize}
              />
            </div>
          </Form.Item>

          <div className="questions-right-search-btn" style={{justifyContent: "flex-end"}}>
                <Button onClick={back}>取消</Button>
                <Button type="primary" htmlType="submit">确定</Button>
            </div>
        </Form>
        
      </div>
    </div>
  );
};

export default React.memo(QuestionForm);
